module.exports = __webpack_public_path__ + "static/media/particles.e09947dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/particles.png
// module id = 474
// module chunks = 0